import styled from '@emotion/styled';

// TODO MOVE TO COMPONENTS

const MenuCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 32px;
    flex: 1;
    width: 100%;
    gap: 0.5rem;
`;

export default MenuCardContainer;
